// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 793 ? "katex" : chunkId) + "." + {"4":"8dc126f8","793":"e3971de8"}[chunkId] + ".chunk.css";
};